import { render, staticRenderFns } from "./stockOverflowAction.vue?vue&type=template&id=30533560&scoped=true"
import script from "./stockOverflowAction.vue?vue&type=script&lang=js"
export * from "./stockOverflowAction.vue?vue&type=script&lang=js"
import style0 from "./stockOverflowAction.vue?vue&type=style&index=0&id=30533560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30533560",
  null
  
)

export default component.exports